import { createStore } from "redux"

import { composeWithDevTools } from "redux-devtools-extension"

// combine all the different reducers in the rootReducer
import rootReducers from "./reducers/rootReducer"

// convert object to string and store in localStorage
function saveToLocalStorage(todoList) {
    try {
        localStorage.setItem("todoList", JSON.stringify(todoList))
    } catch (e) {
        console.warn(e)
    }
}

// load string from local storage and convert into an Object
function loadFromLocalStorage() {
    try {
        const todoList = localStorage.getItem("todoList")
        const todoTemplate = localStorage.getItem("todoTemplate")

        if (todoList === null) todoList = {}
        if (todoTemplate == null) {
            todoTemplate = {
                "800am": "Eat and water",
                "830am": "Turn stuff on",
                "900am": "Plan work",
                "930am": "Small important stuff",
                "1000am": "Code",
                "1030am": "Code",
                "1100am": "Code",
                "1130am": "Code",
                "1200pm": "Check food",
                "1230pm": "Dishes",
                "100pm": "Get food",
                "130pm": "Eat",
                "200pm": "Workout",
                "230pm": "Outside",
                "300pm": "Code",
                "330pm": "Code",
                "400pm": "Nap",
                "430pm": "Nap",
                "500pm": "Code",
                "530pm": "Code",
                "600pm": "Eat",
                "630pm": "Dishes",
                "700pm": "Game",
                "730pm": "Game",
                "800pm": "Code",
                "830pm": "Cardio",
                "900pm": "Shower",
                "930pm": "Game",
                "1000pm": "Teeth",
                "1030pm": "Ready for bed",
                "1100pm": "Sleep",
                "1130pm": "Sleep",
                "1200am": "Sleep",
                "1230am": "Sleep",
            }
        }
        var state = {
            todos: {
                todoList: JSON.parse(todoList),
                currentTodo: null,
                currentTodoName: "Editable Todo Name",
                currentPomodoroNumber: 0,
                todoFinished: 0,
                pomodoroFinished: 0,
                pomodoroTime: 25,
                shortRestTime: 5,
                longRestTime: 15,
                currentDate: new Date(),
                endTime: null,
                todoTemplate: JSON.parse(todoTemplate)
            },
        }

        return state
    } catch (e) {
        console.warn(e)
        return undefined
    }
}

// create our store from our rootReducers and use loadFromLocalStorage to overwrite any values that we already have saved
const store = createStore(
    rootReducers,
    loadFromLocalStorage(),
    composeWithDevTools
)

// listen for store changes and use saveToLocalStorage to save them to localStorage
store.subscribe(function () {
    saveToLocalStorage(store.getState().todos.todoList)
})

export default store
